import { useEffect, useState } from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import {
  kindergartenApplicationsListTable,
  KindergartenApplicationState,
  kinderTableOptionsBuilder,
} from "../../../shared/tableObjects/kindergarten/kindergartenApplicationListTable";
import { useAccount, useMsal } from "@azure/msal-react";

export default function KindergartenApplicationsListSubmitted() {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const apiClient = useApiClient("InvitedApplications");
  const [applicationIds, setApplicationIds] = useState<string>("");

  useEffect(() => {
    const ids = account?.idTokenClaims?.["extension_ApplicationIds"] as string;
    setApplicationIds(ids);
  }, []);

  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Applications",
      icon: "list-icon",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        {applicationIds.length > 0 && (
          <Table
            apiClient={apiClient}
            columns={kindergartenApplicationsListTable("/kindergarten/submittedApplications")}
            route={`allMyInvited/${applicationIds}`}
            tableOptions={kinderTableOptionsBuilder(KindergartenApplicationState.submitted)}
          />
        )}
      </div>
    </>
  );
}
